module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-right-nav"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.messageCenter')))])]), _vm._v(" "), _c('div', {
    staticClass: "message-right-list"
  }, [_vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "message-item"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "content-top"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(message.subject))]), _vm._v(" "), _c('span', {
      staticClass: "messsage-date"
    }, [_vm._v(_vm._s(_vm.getFormatDate(new Date(message.createTime))))])]), _vm._v(" "), _c('div', {
      staticClass: "content-bottom",
      class: {
        'unread': !message.isRead
      },
      domProps: {
        "innerHTML": _vm._s(message.content)
      }
    })])])
  }), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "justify-content": "flex-end"
    }
  }, [_c('div', {
    staticClass: "message-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-count": _vm.totalPages,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.getMessages
    }
  })], 1)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-icon"
  }, [_c('img', {
    attrs: {
      "src": "http://static2.test.ximalaya.com/lib/a2/last/css/img/default/cat2.png?version=1482913369915"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51122a79!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/Messages.vue
// module id = 1028
// module chunks = 0